<div class="group" [formGroup]="commissionGroup">
  <input type="text" otInput formControlName="value" [readonly]="disabled" [textMask]="currencyMask" [required]="required">
  <ot-select-box class="no-min-width" formControlName="type" [readonly]="disabled" [options]="types"></ot-select-box>
</div>
